module.exports = __webpack_public_path__ + "static/media/PREFINAL-SAM-DIABETES.b9413bb7.pdf";